import { render, staticRenderFns } from "./user-detail.vue?vue&type=template&id=1d51da8b&scoped=true&"
import script from "./user-detail.vue?vue&type=script&lang=js&"
export * from "./user-detail.vue?vue&type=script&lang=js&"
import style0 from "./user-detail.vue?vue&type=style&index=0&id=1d51da8b&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d51da8b",
  null
  
)

export default component.exports